<template>
  <div class="main">
    <span class="main-config">
      <div  v-if="!readOnly" class="op">
      <label>{{ $t('operacoes') }} </label>
      <b-form-select
        class="input-pentagro"
        v-model="operationSelected"
        :options="operations"
      ></b-form-select>
    </div>
    <b-form v-if="operationSelected" class="b-layout" @submit.prevent="">
      <b-card class="pr-4">
        <div v-for="(prop, index) in equipments" :key="prop.caption + index">
          <b-form-checkbox
              class="switch-item"
              v-model="prop.value"
              @change="ChangeOnOff($event, prop)"
              switch
              >
              {{ prop.equipName }}
            </b-form-checkbox>
        </div>
      </b-card>

      <div class="attr-list">
        <div class="inp">
          <label>{{ $t('taxa-de-lodo') }} </label>
          <b-input
            max="100"
            min="1"
            class="inp-number input-pentagro"
            type="number"
            v-model="Tx_L.value"
          ></b-input>
        </div>

        <div class="inp">
          <label>{{ $t('volume-instalado-m') }} </label>
          <p>{{ Volume.value | ParseNumber  }}</p>
        </div>

        <div class="inp">
          <label>{{ $t('tempo-residencia-h') }} </label>
          <p>{{ TempoResidencia.value | ParseNumber  }}</p>
        </div>

        <div class="inp">
          <label>{{ $t('ocupacao-1') }} </label>
          <p>{{ TxUtilizacao.value | ParseNumber }}</p>
        </div>
      </div>
    </b-form>
    </span>
    <div v-if="jokerEquipmentList.length" class="joker">
      <label class="mt-2">{{ $t('equipamentos-coringas') }}</label>
      <div v-for="(joker, i) in jokerEquipmentList" :key="i">
        <b-form>
          <div class="ml-2 mr-2">
            <TextToInput 
              :text="joker.caption"
              @sendText="updateCaption($event, joker)">
            </TextToInput>
          </div>
          <span class="b-layout">
            <b-card v-if="equipments.length > 0">
              <div v-for="(prop, index) in joker.equipments" :key="prop.caption + index">
                <b-form-checkbox
                    class="switch-item"
                    v-model="prop.value"
                    @change="ChangeOnOffJoker($event, prop, equipments, joker)"
                    switch
                    >
                    {{ prop.equipName }}
                </b-form-checkbox>
              </div>
            </b-card>
            <div class="ml-3" v-if="equipments.length > 0">
              <b-card>
                <div class="inp mb-2">
                  <label>{{ $t('volume-instalado-m-0') }} </label>
                  <label class="input-data" >{{ joker.capacidade.value | ParseNumber }}</label>
                </div>
                <div class="inp">
                  <label>{{ $t('ocupacao-0') }} </label>
                  <label class="input-data">{{ joker.Ocupacao.value | ParseNumber }}</label>
                </div>
              </b-card>
            </div>
          </span>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
import { SingletonEnginnering } from "../_service/singletonEngineering";
import { ParseToNumber } from "../../utils/tools";
import { JokerEquipmentMixin } from '../../../mixins/jokerEquipmentsMixin'
import TextToInput from "../../../template/TextToInput"
import { FiltersMixin } from "../../../mixins/filtersMixin";

export default {
  props: {
    node: {
      type: Object,
      default: null,
    },
    readOnly:{
      type: Boolean,
      default: false,
    }
  },

  components: { TextToInput },

  mixins: [ JokerEquipmentMixin, FiltersMixin ],

  data() {
    return {
      Tx_L: {},
      Volume: {},
      TempoResidencia: {},
      TxUtilizacao: {},
      operations: [{ value: null, text:this.$t('selecione-um-decantador') }],
      operationSelected: null,
      currents: [{ value: null, text:this.$t('selecione-um-decantador') }],
      current: null,
      operationAttributeList: [],
      attributesList:this.$t('selecione-um-decantador'),
      firstLoad: false,
      equipments: [],
      equipCap: [],
      attrList: [
        "Tx_L",
        "TempoResidencia",
        "Volume",
        "TxUtilizacao"
      ],
    };
  },

  watch: {
    operationSelected(value) {
      if (this.firstLoad) {
        this.firstLoad = false;
        return;
      }

      this.loadEquipments();
      this.buildJokerEquipment(value)


      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));

      this.attrList.forEach((attr) => {
        this[attr] = this.operationAttributeList.find((p) => attr == p.caption);
        if (this[attr]) this[attr].value = ParseToNumber(this[attr].value);
      });
      this.updateNode();
    },

    'Tx_L.value'(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.updateNode();
      }
    }
  },

  methods: {
    loadNode() {
      if (this.node.data[0].index) {
        this.buildJokerEquipment(this.node.data[0].index, this.node.jokerCaption)
        this.firstLoad = true;
        this.operationSelected = this.node.data[0].index;
        this.loadNotInput();
      }

      this.equipments = new Array();
      
      this.node.data.forEach((p) => {
        if (this.attrList.includes(p.caption)) {
          p.value = ParseToNumber(p.value);
          this[p.caption] = p;
        }
        
        if (p.equipName) {
          let result = ParseToNumber(p.value) ? true : false;
          p.value = result;
          this.equipments.push(p);
        }
      });
      this.loadEquipments();
    },

    loadNotInput() {
      this.operationAttributeList =
        SingletonEnginnering.getOperationsProperties(
          this.operationSelected
        ).filter((operation) => this.attrList.includes(operation.key));
      let attrNotInput = this.attrList.slice(1);

      attrNotInput.forEach((attrName) => {
        this[attrName] = this.operationAttributeList.find(
          (p) => attrName == p.caption
        );
        if (this[attrName])
          this[attrName].value = ParseToNumber(this[attrName].value);
      });
    },

    loadEquipments() {
      let equipsName = SingletonEnginnering.getOperationsEquipments(
        this.operationSelected
      );
      let propsByEquipment = SingletonEnginnering.getEquipamentsProperties(
        this.operationSelected
      );
      let auxEquipment = new Array();

      equipsName.forEach((e) => {
        let props = propsByEquipment[e];
        Object.keys(props).forEach((p) => {
          if (props[p].caption == "Status") {
            props[p].value = parseInt(props[p].value) ? true : false;
            auxEquipment.push(props[p]);
          }

          if (props[p].caption == "Capacidade") {
            this.equipCap.push(props[p]);
          }
        });
      });

      this.equipments = auxEquipment;
    },

    updateNode() {
      let attrs = [
        this.Tx_L.clone(),
      ];
      this.equipments.forEach((e) => {
        let prop = e.clone();
        prop.value = e.value ? '1,00' : '0,00' ;
        attrs.push(prop);
      });

      this.node.attrs = attrs;
      this.updateJokerNode(this.node, this.jokerEquipmentList)
    },

    loadOperation() {
      let opList = SingletonEnginnering.operations.filter((o) =>
        o.match(/Decantador/)
      );
      this.operations.splice(1);
      opList.forEach((op) => this.operations.push({ value: op, text: op }));
    },

    ChangeCapacity() {
      if (this.Volume) {
        this.Volume.value = 0;
        this.equipments.forEach((e) => {
          let cap = this.equipCap.find((c) => c.equipName == e.equipName);
          let isTrue = JSON.parse(e.value);
          if (isTrue && cap)
            this.Volume.value += parseFloat(
              String(cap.value).replace(",", ".")
            );
        
      });
      }
    },

    ChangeOnOff(event, prop) {
      prop.value = event;
      this.ChangeCapacity();
      this.switchStatusJoker(prop, this.equipments, false, this.Changecapacidade)
      this.updateNode();
    },
  },

  mounted() {
    this.loadOperation();
    this.loadNode();
    this.ChangeCapacity();
    this.changeExternalCapacity = function () { this.ChangeCapacity() }
    this.updataNodeInMixin = function () { this.updateNode()}
  },
};
</script>

<style scoped>
.main{
  display: flex;
}

.main-config{
  width: 550px;
}

.width-155{
  width: 155px;
}

.input-data{
  width: 70px;
  text-align: right;
}

form {
  padding: 10px;
  color: #0009;
}

.b-layout {
  display: flex;
  justify-content: space-between;
}

input {
  margin-left: 5px;
  width: 100px;
  text-align: right;
}

.inp > p,
.inp {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.op {
  margin: 2%;
}

.attr-list{
  min-width: 275px;
}
</style>